export default "__VITE_ASSET__Bugg84LB__"